import { FC } from 'react';
import { Link } from 'src/components/link';
import { Sidebar } from 'src/components/sidebar';
import { Sticky } from 'src/components/sticky';
import { Successful } from 'src/hooks/use-axios';
import { useFeatureFlags } from 'src/hooks/use-feature-flags';
import { OrganisationServiceRequest } from 'src/pages/settings/organisation/use-organisation-service';

export const SettingsSidebar: FC<{
  organisationService: Successful<OrganisationServiceRequest>;
}> = ({ organisationService }) => {
  const { userInvitations } = useFeatureFlags();
  return (
    <Sticky>
      <Sidebar>
        <Link mode="sidebar" to="/settings/profile">
          Profile
        </Link>

        <Link mode="sidebar" to="/settings/notifications">
          Notification
          <br />
          Settings
        </Link>

        {userInvitations &&
        organisationService.response.data._links.getUserDetails ? (
          <Link mode="sidebar" to="/settings/organisation/users">
            User Management
          </Link>
        ) : null}
      </Sidebar>
    </Sticky>
  );
};
